var map = {
	"./3d_payment_deadline.svg": "e561",
	"./3ds.png": "5663",
	"./ada.svg": "3ab7",
	"./arrow-reload-horizontal-sharp.svg": "6292",
	"./arrow.svg": "b94f",
	"./bancontact.svg": "ee50",
	"./bg.png": "d68e",
	"./bg2.png": "028e",
	"./bitcoin.png": "d706",
	"./blik.svg": "0458",
	"./btc.svg": "6fe1",
	"./chart.svg": "798c",
	"./chatting.svg": "667a",
	"./check.svg": "f222",
	"./close.svg": "bf37",
	"./customer-service.svg": "1968",
	"./dash.svg": "89f3",
	"./decor.svg": "a07d",
	"./doc.svg": "6700",
	"./doc1.svg": "02c8",
	"./doc2.svg": "b855",
	"./down2.svg": "3c4f",
	"./earth.svg": "b830",
	"./ellipse.svg": "0249",
	"./eps.svg": "cde2",
	"./eth.svg": "b872",
	"./exchange-arrows.svg": "dd0c",
	"./exchange.svg": "2f0b",
	"./facebook.svg": "aaa3",
	"./folder.svg": "abfe",
	"./footer-bg.jpg": "6bfc",
	"./giropay.svg": "7f1d",
	"./ideal.svg": "eabe",
	"./instagram.svg": "54e6",
	"./klarna.svg": "cac1",
	"./logo.svg": "9b19",
	"./logo2.svg": "2d28",
	"./ltc.svg": "fde8",
	"./mc.svg": "454d",
	"./mc_symbol.svg": "053e",
	"./paidby.svg": "b68d",
	"./paysafecard.png": "dfcd",
	"./security.svg": "b464",
	"./shield.svg": "3cb2",
	"./sofortuber.svg": "9b86",
	"./stonks.svg": "178e",
	"./stopwatch.svg": "2fc3",
	"./support.svg": "2621",
	"./time.svg": "f490",
	"./trustly.svg": "2b15",
	"./trx.svg": "f9f1",
	"./twitter.svg": "a3df",
	"./usdc.svg": "6a14",
	"./usdt.svg": "086e",
	"./user.svg": "0f62",
	"./visa-logo.svg": "04b5",
	"./visa.svg": "0239",
	"./xrp.svg": "e081"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";